import httpClient from '../httpClient';

export async function getAllSes() {
  try {
    const response = await httpClient.get(`/api/ses`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de SES: ' + error);
  }
}

export async function getSes(sesID: string) {
  try {
    const response = await httpClient.get(`/api/ses/${sesID}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter SES: ' + error);
  }
}

export async function getAllNaturezasjuridicas() {
  try {
    const response = await httpClient.get(`/api/naturezajuridica`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Naturezas Jurídicas: ' + error);
  }
}

export async function getAllMunicipiosIbge() {
  try {
    const response = await httpClient.get(`/api/municipioibge`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Municípios IBGE: ' + error);
  }
}

export async function getDadosCnes(codigoCnes: string) {
  try {
    const response = await httpClient.get(`/api/consulta-cnes/${codigoCnes}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter SES: ' + error);
  }
}
